export const GenericService = {
    
    selectOptions: async function (service, setter)
	{
		try {
			setter([
				{ value: '', label: 'Carregando' },
			]);
			const response = await service.list();
			const options = response.data.map(item => ({
				value: item.id,
				label: item.title
			}));
			setter([
				{ value: '', label: 'Selecione' },
				...options
			]);
		} catch (error) {
			console.error(`Error fetching:`, error);
			setter([{ value: '', label: `Erro ao carregar` }]);
		}
	},
}